// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — alert-button.styled.classic.js, новая — alert-button.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './alert-button.styled.classic';
import * as cp from './alert-button.styled.cp';

export const AlarmButton = isCp ? cp.AlarmButton : undefined;
export const Content = isCp ? cp.Content : classic.Content;
export const ImgWrapper = isCp ? undefined : classic.ImgWrapper;
